//================= [JS] ======================================
import {i18n} from '@/common/i18n';
import {Routes} from '@/common/enums/Routes';
import {Permissions} from '@simpleforyou/coaching-shared';
//================= [VUE COMPONENTS] ==========================

export const liveCoachingRoutes = [
  {
    path: i18n.global.t('routes.liveCoaching'),
    name: Routes.LIVE_COACHING,
    component: () => import('@/components/liveCoaching/LiveCoaching.vue'),
    meta: {
      title: i18n.global.t('titles.liveCoaching'),
      active: 'liveCoaching',
      roles: [Permissions.ROLE_LIVE_COACHING_INDEX],
    },
  },
  // T00AZBXVXZZ5 — The area is called "Kalender" now and lives at /kalender.
  // Old links and bookmarks to /live-coaching keep working.
  {
    path: '/live-coaching',
    redirect: {name: Routes.LIVE_COACHING},
  },
];
